import { createError } from '@common/neo.tax';
import { Input } from '@ui-components/neo.tax';
import React from 'react';

import { InputFormType } from './forms.types';

export const InputForm = ({ form }: { form: InputFormType }): React.ReactElement => {
  const handleChangeValue = (value: number | string): void => {
    form.onChange(value.toString());
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    handleChangeValue(event.target.value);
  };

  const error = form.validator?.(form.value);
  if (error !== undefined && typeof error !== 'string') {
    throw createError(
      'ValidationTypeError',
      `InputForm validator for form key "${form.key}" should return a string or undefined; returned ${typeof error}.`,
    );
  }

  const inputProps = {
    value: form.value ?? '',
    placeholder: form.placeholder || '',
    name: form.key,
    type: form.type || 'text',
    pattern: form.pattern,
    inlineLeadingContent: form.inlineLeadingContent,
    min: form.min,
    max: form.max,
    maxLength: form.maxLength,
    error: form.value !== '' && Boolean(error),
    errorText: form.getErrorText(error),
    disabled: form.disabled,
    id: form.id,
    trailingButton: form.trailingButton,
  };

  return form.mask === undefined ? (
    <Input onChange={handleChange} {...inputProps} />
  ) : (
    <Input
      onChange={handleChangeValue}
      mask={form.mask}
      maskReturnValueType={form.maskReturnValueType}
      {...inputProps}
    />
  );
};
